import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route} from 'react-router';

import SignOut from './auth/Signout';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<div />} />

      <Route path="/signout" Component={SignOut} />

    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

